import { Card } from "antd";

const colors = {
    primary: '#1890ff',
    secondary: '#242166',
    success: '#52c41a',
    warning: '#faad14',
    danger: '#ff4d4f',
    info: '#13c2c2',
    lightBg: '#f5f7fa',
    cardBg: '#ffffff',
    textPrimary: '#262626',
    textSecondary: '#8c8c8c',
    border: '#e8e8e8',
    gradient: 'linear-gradient(135deg, #1890ff 0%, #242166 100%)',
};

export const StatCard = ({ title, value, subtitle, icon, iconBg, gradient, onClick, active }) => {
    // Taille de police ADAPTATIVE : les valeurs longues (ex. « 85 002 / 575 002 ») débordaient à
    // 32px et cassaient sur 2-3 lignes, déséquilibrant la hauteur des cards. On réduit la police
    // selon la longueur du texte pour garder le nombre sur une ligne autant que possible.
    const valueText = (typeof value === 'string' || typeof value === 'number') ? String(value) : '';
    const valueFontSize = valueText.length > 15 ? '22px'
        : valueText.length > 11 ? '26px'
            : valueText.length > 8 ? '29px'
                : '32px';

    return (
        <Card
            bordered={false}
            style={{
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                transition: 'all 0.3s ease',
                cursor: onClick ? 'pointer' : 'default',
                overflow: 'hidden',
                position: 'relative',
                border: active ? `1px solid ${colors.primary}` : undefined
            }}
            bodyStyle={{ padding: '24px' }}
            hoverable
            onClick={onClick}
        >
            <div style={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: '100px',
                height: '100px',
                background: gradient,
                opacity: 0.1,
                borderRadius: '0 0 0 100%'
            }} />
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '12px', position: 'relative' }}>
                {/* flex:1 + minWidth:0 : le bloc texte peut rétrécir dans la ligne flex (sinon le
                    nombre déborde et pousse l'icône). */}
                <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ color: colors.textSecondary, fontSize: '14px', marginBottom: '8px' }}>
                        {title}
                    </div>
                    <div style={{ fontSize: valueFontSize, fontWeight: '700', color: colors.textPrimary, marginBottom: '4px', lineHeight: 1.15, wordBreak: 'break-word' }}>
                        {value}
                    </div>
                    <div style={{ color: colors.textSecondary, fontSize: '12px' }}>
                        {subtitle}
                    </div>
                </div>
                {/* flexShrink:0 : l'icône garde toujours ses 56px. */}
                <div style={{
                    width: '56px',
                    height: '56px',
                    flexShrink: 0,
                    borderRadius: '12px',
                    background: iconBg,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px'
                }}>
                    <i className={icon} style={{ color: '#fff' }} />
                </div>
            </div>
        </Card>
    );
};
